import { z } from 'zod';
import { nonEmptyString, utcNaiveTimestamp } from './common.ts';

export const serviceStatusValues = ['operational', 'degraded', 'outage', 'maintenance'] as const;
export const serviceStatus = z.enum(serviceStatusValues);
export type ServiceStatus = z.infer<typeof serviceStatus>;

export const service = z.object({
  id: z.number().int().positive(),
  name: nonEmptyString,
  // Legacy is permissive on status — accept any string but suggest known values.
  status: z.string(),
  created_at: utcNaiveTimestamp,
  updated_at: utcNaiveTimestamp,
});
export type Service = z.infer<typeof service>;

export const createServiceInput = z.object({
  name: nonEmptyString,
  status: z.string().optional(),
});
export type CreateServiceInput = z.infer<typeof createServiceInput>;

export const serviceListResponse = z.array(service);

export const serviceNameParam = z.object({
  name: nonEmptyString,
});
